import { PERMISSIONS } from "../../../../../core/enums/permissions.enum";
import type { ApiResponse } from "../../../../../core/models/response.model";
import type {
  DemoElectronicContractBootstrapModel,
  DemoElectronicContractBootstrapResult,
} from "../../../../../core/models/electronic-contract.model";

export function canBootstrapDemoTemplates(claims: ReadonlyArray<{ id: string }>, userName?: string): boolean {
  return userName === "admin" || claims.some(claim => claim.id === PERMISSIONS.ADMIN.key);
}

export function validateDemoTemplateConfiguration(values: DemoElectronicContractBootstrapModel) {
  const errors: Partial<Record<keyof DemoElectronicContractBootstrapModel, string>> = {};
  if (!/^[A-Za-z0-9_-]{1,64}$/.test(values.connectionProfile.trim())) {
    errors.connectionProfile = "Nhập tên profile đã được cấu hình trên server (chữ, số, _ hoặc -, tối đa 64 ký tự).";
  }
  const isEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  if (!isEmail(values.companyEmail)) errors.companyEmail = "Nhập email tài khoản API công ty trên tenant demo.";
  if (!isEmail(values.surveyEmail)) errors.surveyEmail = "Nhập email nhân viên khảo sát nội bộ trên tenant demo.";
  else if (values.surveyEmail.trim().toLowerCase() === values.companyEmail.trim().toLowerCase()) {
    errors.surveyEmail = "Email khảo sát phải khác tài khoản công ty.";
  }
  return errors;
}

type BootstrapOutcome = { success: true; created: number; skipped: number } | { success: false; error: string };

export function getBootstrapOutcome(response: ApiResponse<DemoElectronicContractBootstrapResult[]> | undefined): BootstrapOutcome {
  if (response?.code !== "00" || !Array.isArray(response.result)
    || !response.result.every(item => typeof item?.created === "boolean")) {
    return { success: false, error: response?.errorMessage || "Không khởi tạo được mẫu. Kiểm tra kết nối và cấu hình server." };
  }
  return {
    success: true,
    created: response.result.filter(item => item.created).length,
    skipped: response.result.filter(item => !item.created).length,
  };
}
